<template>
  <Header />
  <Herosection />
  <AboutMe />
  <Footer />
</template>

<script>
import Header from "@/components/Header.vue";
import Herosection from "@/components/HeroSectionPage.vue";
import Footer from "@/components/Footer.vue";
import AboutMe from "@/components/views/AboutMe.vue";

export default {
  components: {
    Header,
    Herosection,
    Footer,
    AboutMe,
  },
};
</script>
